module.exports = __webpack_public_path__ + "static/media/Workshop on Robust FL on Edge Devices 2025.822f5e26.pdf";